import { isAnyOf, Middleware, PayloadAction, ThunkDispatch } from '@reduxjs/toolkit';
import { availableCountries } from '@ubnt/wifi-calculator/utils/regulatoryLimits';
import { settingsCountrySelector, settingsCountryUpdate, settingsUserCountryUpdate } from 'modules/settings/slice';
import { RootState } from 'app/store/reducer';
import { fetchPrices } from 'modules/prices/slice';
import { getStoreCountry } from 'modules/prices/utils';

const isCountryChangeAction = isAnyOf(settingsCountryUpdate, settingsUserCountryUpdate);

export const pricesMiddleware: Middleware<unknown, RootState, ThunkDispatch<RootState, never, PayloadAction>> =
  (store) => (next) => (action) => {
    const result = next(action);

    if (isCountryChangeAction(action)) {
      const dispatch = store.dispatch;
      const country = settingsCountrySelector(store.getState());

      if (availableCountries.includes(country)) {
        void dispatch(fetchPrices(getStoreCountry(country)));
      }
    }

    return result;
  };
